export const TRANSACTIONS_CARD_BEGIN = 'TRANSACTIONS_CARD_BEGIN';
export const TRANSACTIONS_CARD_SUCCESS = 'TRANSACTIONS_CARD_SUCCESS';
export const TRANSACTIONS_CARD_FAILURE = 'TRANSACTIONS_CARD_FAILURE';

const fetchTransactionsCardSuccess = (data) => ({
  type: TRANSACTIONS_CARD_SUCCESS,
  payload: data,
});

const fetchTransactionsCardBegin = () => ({
  type: TRANSACTIONS_CARD_BEGIN,
});

const fetchTransactionsCardFailure = (error) => ({
  type: TRANSACTIONS_CARD_FAILURE,
  error
});

export const fetchTransactionsCard = (cardNumber, page, pageSize) => (dispatch) => {
  dispatch(fetchTransactionsCardBegin());

  return fetch(`/api/cards/${cardNumber}/transactions?page=${page}&pageSize=${pageSize}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }})
    .then(response => handleErrors(response))
    .then(data => dispatch(fetchTransactionsCardSuccess(data)))
    .catch(err => dispatch(fetchTransactionsCardFailure(err.message)));
}

function handleErrors(response) {
  if (!response.ok) {
    return response.json().then(errorResponse => {
      let msg;
      if (errorResponse.extraParameters && Array.isArray(errorResponse.extraParameters.json)) {
        msg = errorResponse.extraParameters.json[0];
      }
      if (response.status === 404) {
        throw new Error(msg || errorResponse.detail || 'Deze pas werd niet gevonden.');
      } else if (response.status === 403) {
        throw new Error(msg || 'U heeft geen toegang.');
      } else {
        throw new Error(msg || 'Er is een fout opgetreden.');
      }
    }).catch(err => {
      throw err;
    });
  }
  return response.json();
}